import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './wrike-folder-meeting.types';
import * as constants from './wrike-folder-meeting.constants';

export const wrikeFolderMeetingReducer = generateResourceReducer<types.IWrikeFolderMeeting>({
  STORE: constants.STORE_WRIKE_FOLDER_MEETING,
  CLEAR: constants.CLEAR_WRIKE_FOLDER_MEETING,
});
